<template>
  <v-app>
    <router-view />
    <v-snackbar
      v-for="(snackbar, index) in allSnakbars.filter(s => s.showing)"
      :key="snackbar.text + Math.random()"
      v-model="snackbar.showing"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      bottom
      right
      :style="`padding-bottom: ${(index * 70) + 8}px`"
      style="z-index:2000"
    >
      <span style="color:black">{{snackbar.text}}</span>
      <v-btn text @click="snackbar.showing = false">
        <v-icon dark>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "App",
  components: {},
  data: () => ({
    app_version:"0.1.14"
  }),
  methods: {},
  watch: {},
  created(){
    // const fs = require('fs')
    // const packageJson = fs.readFileSync('./package.json')
    // const version = JSON.parse(packageJson).version 
    // console.log("version")
    // console.log(version)
    if(localStorage.getItem("app-ver") == null){
     // alert("1111")
      localStorage.setItem("app-ver",this.app_version)
    }else if(localStorage.getItem("app-ver") !=this.app_version ){
    //  alert("2222")
      localStorage.setItem("app-ver",this.app_version)
      window.location.reload(true);
    }else{
      //alert("3333")
    }
  },
  mounted() {
    localStorage.setItem("latitude","NA")
    localStorage.setItem("longitude","NA")
    if(navigator.geolocation){
      navigator.geolocation.getCurrentPosition(position => {
        localStorage.setItem("latitude", position.coords.latitude)
        localStorage.setItem("longitude",position.coords.longitude)
      })
    }
    // // console.log("1")
    // localStorage.setItem("requestIP","null")
    // axios.get('https://api.ipify.org/?format=json')
    //   .then(response => (
    //     // console.log("ipify response:"+response),
    //     localStorage.setItem("requestIP",response)
    //   ))
    // // console.log("2")
  },
  computed: mapGetters(["allSnakbars"]),
};
</script>
<style>
body {
  background-color: #e8e8e8;
}
@media print {
  body {
    height: 100%;
    width: 100%;
  }
  .no-display {
    display: none !important;
  }
}
</style>
